(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/models/league.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/models/league.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  svs.statistics.models.League = Backbone.Model.extend({
    url: function() {
      return svs.core.jupiter.url() + '/sport/1/leagues/' + this.get('leagueId');
    },
    defaults: function() {
      if ((((svs.statistics || {}).data || {}).leagueModels || {}).league) {
        return this.parse(svs.statistics.data.leagueModels.league);
      }
    },
    initialize: function() {},
    parse: function(response) {
      if (response.league) {
        if (response.league.underlyingLeagues) {
          response.league.underlyingLeagues = _.filter(
            response.league.underlyingLeagues,
            function(league) {
              return league.rank > -1;
            }
          );
          response.league.underlyingLeagues = _.sortBy(
            response.league.underlyingLeagues,
            function(league) {
              return league.name;
            }
          );
          response.league.underlyingLeagues = _.sortBy(
            response.league.underlyingLeagues,
            function(league) {
              if (league.rank === 0) {
                return 1000000;
              }
              return league.rank;
            }
          );
        }
      }
      return response;
    },
    dispose: function() {
      this.clear(true);
    }
  });
})(Backbone, _, svs);

 })(window);